import Component from 'components/pages/PrivacyPromise/PrivacyPromise.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('privacy-promise');
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Privacy Promise',
    description: 'Privacy Promise Page',
  },
});
